// frontend/src/features/equipment/EquipmentSetupWizard/steps/ReviewStep.tsx
import { Button, Stack, Text, Title } from '@mantine/core';
import { ReviewList } from '../components/ReviewList';
import type { PendingEquipment } from '../types';

type SessionSavedEquipment = PendingEquipment & { category?: string };

interface ReviewStepProps {
  /** Equipment entries saved during this wizard session */
  sessionSavedEquipment: SessionSavedEquipment[];
  /** Callback when finish is clicked */
  onFinish: () => void;
}

/**
 * Final review step showing all equipment saved during this session.
 */
export function ReviewStep({
  sessionSavedEquipment,
  onFinish,
}: ReviewStepProps) {
  return (
    <Stack gap="lg" data-testid="review-step">
      <Title order={4}>Session Summary</Title>
      <Text size="sm" c="dimmed">
        Here&apos;s what was saved during this setup session.
      </Text>

      <ReviewList sessionSavedEquipment={sessionSavedEquipment} />

      <Stack gap="xs">
        <Button fullWidth onClick={onFinish}>
          Finish
        </Button>
      </Stack>
    </Stack>
  );
}
